var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.725,
    height: 22.14,
    viewBox: "0 0 23.725 22.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25107",
    "data-name": "Rectangle 25107",
    width: 23.725,
    height: 22.14,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86059",
    "data-name": "Group 86059",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86058",
    "data-name": "Group 86058",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242451",
    "data-name": "Path 242451",
    d: "M17.481,17.575a.368.368,0,0,1-.262-.109l-4.492-4.492a.371.371,0,0,1,.524-.524l4.492,4.492a.371.371,0,0,1-.262.633Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242452",
    "data-name": "Path 242452",
    d: "M16,19.057a.368.368,0,0,1-.262-.109l-4.465-4.464a.371.371,0,0,1,.524-.525l4.465,4.465a.371.371,0,0,1-.262.633",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242453",
    "data-name": "Path 242453",
    d: "M19.516,22.14a1.414,1.414,0,0,1-1-.415l-1.3-1.3a.371.371,0,1,1,.524-.525l1.3,1.3A.677.677,0,0,0,20,20.243l-1.3-1.3a.371.371,0,1,1,.525-.524l1.295,1.3a1.418,1.418,0,0,1-1,2.421Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242454",
    "data-name": "Path 242454",
    d: "M17.081,20.938a.373.373,0,0,1-.262-.108l-1.481-1.482a.37.37,0,0,1,0-.524l2.281-2.281a.37.37,0,0,1,.524,0l1.481,1.481a.37.37,0,0,1,0,.524l-2.28,2.282a.374.374,0,0,1-.263.108m-.957-1.852.957.957,1.757-1.757-.957-.957Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242455",
    "data-name": "Path 242455",
    d: "M1.394,13.394a.371.371,0,0,1-.371-.371V10.656a10.648,10.648,0,0,1,21.288-.433.37.37,0,0,1-.74.038v-.008a9.907,9.907,0,0,0-19.8.4v2.367A.371.371,0,0,1,1.394,13.394Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242456",
    "data-name": "Path 242456",
    d: "M21.7,8.792a.4.4,0,0,1-.09-.011l-3.089-.768a1.028,1.028,0,0,0-.487,0l-.9.218a1.758,1.758,0,0,1-1.859-2.717A7.144,7.144,0,0,0,16.2,1.62a.371.371,0,0,1,.742,0,7.843,7.843,0,0,1-1.052,4.319,1.017,1.017,0,0,0,.251,1.416.974.974,0,0,0,.143.084,1.016,1.016,0,0,0,.682.071l.9-.218a1.763,1.763,0,0,1,.842,0l3.089.768a.37.37,0,0,1-.089.73",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242457",
    "data-name": "Path 242457",
    d: "M1.394,12.124a.371.371,0,0,1-.169-.7l1.759-.9a1.546,1.546,0,0,1,1.355-.03l.95.434a.814.814,0,0,0,1.078-.4.787.787,0,0,0,.061-.193l.022-.12a1.538,1.538,0,0,1,.272-.637.813.813,0,0,0-.18-1.137A.8.8,0,0,0,6.22,8.3l-.744-.146A1.556,1.556,0,0,1,4.565,7.6l-.148-.184a.815.815,0,0,0-1.027-.2l-1.371.758a.371.371,0,0,1-.358-.649l1.37-.758a1.553,1.553,0,0,1,1.963.385l.148.183a.814.814,0,0,0,.476.287l.745.146a1.555,1.555,0,0,1,.958,2.441.849.849,0,0,0-.09.158.819.819,0,0,0-.052.175l-.022.12a1.554,1.554,0,0,1-1.808,1.252,1.573,1.573,0,0,1-.368-.115l-.951-.434a.811.811,0,0,0-.708.015l-1.76.9A.363.363,0,0,1,1.394,12.124Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242458",
    "data-name": "Path 242458",
    d: "M8.695,5.392a1.131,1.131,0,0,1-1.074-.751.4.4,0,0,0-.376-.263H6.361A1.142,1.142,0,0,1,5.22,3.237V2.37a.371.371,0,1,1,.741,0v.867a.4.4,0,0,0,.4.4h.884a1.145,1.145,0,0,1,1.073.751.4.4,0,0,0,.725.056l.235-.427a1.138,1.138,0,0,1,1.211-.571l.467.088a.4.4,0,0,0,.435-.222l.367-.774,0,0,.005-.01a1.587,1.587,0,0,0-.1-1.571L11.416.585a.371.371,0,1,1,.616-.412l.246.368a2.331,2.331,0,0,1,.151,2.313l0,0-.366.771a1.14,1.14,0,0,1-1.242.632l-.467-.088a.4.4,0,0,0-.425.2L9.693,4.8A1.126,1.126,0,0,1,8.695,5.392ZM12.42,2.871Zm.008-.015h0v0Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242459",
    "data-name": "Path 242459",
    d: "M10.252,9.387a1.232,1.232,0,0,1-.514-.115,1.184,1.184,0,0,1-.691-1.263l.09-.644a1.2,1.2,0,0,1,.671-.921l2.2-1.06a.371.371,0,0,1,.447.1l.566.689a1.206,1.206,0,0,1-.932,1.972.468.468,0,0,0-.349.158l-.593.672A1.19,1.19,0,0,1,10.252,9.387Zm1.815-3.209-1.937.934a.464.464,0,0,0-.259.355l-.09.645a.465.465,0,0,0,.81.372l.593-.673a1.206,1.206,0,0,1,.9-.408.465.465,0,0,0,.359-.761Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242460",
    "data-name": "Path 242460",
    d: "M1.473,15.594a1.472,1.472,0,0,1,0-2.944h7.5a1.186,1.186,0,0,0,.863-.376l1.668-1.794a1.929,1.929,0,0,1,1.407-.613h9.342a1.472,1.472,0,0,1,0,2.944H13.866a1.188,1.188,0,0,0-.864.376l-1.668,1.794a1.927,1.927,0,0,1-1.406.613Zm8.637-3.068.271.252a1.919,1.919,0,0,1-1.406.613h-7.5a.731.731,0,1,0,0,1.461H9.928a1.178,1.178,0,0,0,.863-.376l1.668-1.794a1.924,1.924,0,0,1,1.407-.612h8.389a.73.73,0,1,0,0-1.461H12.913a1.179,1.179,0,0,0-.864.376l-1.668,1.793Z",
    fill: "#ff6464",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsure);
export default __webpack_public_path__ + "static/media/insure.d4fab73a38446aa9cfeece62738a5956.svg";
export { ForwardRef as ReactComponent };